import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { COLOR_ACCENT, CratCircle, Section } from 'shared';

export const Resources = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Section>
        <Typography
          variant="h1"
          className="no-resize"
          sx={{
            [theme.breakpoints.down('sm')]: {
              fontSize: 30,
            },
            mb: {
              xs: 2.5,
              sm: 12,
            },
          }}
        >
          <Typography fontSize="inherit" fontWeight="inherit" color={COLOR_ACCENT} component="span">
            CratD2C 12+
          </Typography>
          1 Ecosystem
        </Typography>
        <Typography
          variant="subtitle1"
          className="summary sm secondary regular"
          textAlign={{ sm: 'center' }}
          fontSize={{ xs: 15, sm: 20 }}
          lineHeight={{ xs: '24px', sm: '32px' }}
          sx={{
            mb: {
              xs: 4,
              sm: 14,
            },
            span: {
              fontSize: 'inherit',
            },
          }}
        >
          {isMobile ? (
            <>
              CratD2C is more than just a blockchain - it’s a whole{' '}
              <Typography component="span">digital economy.</Typography>
              <br />
              Here’s a breakdown of the <Typography component="span">12+1 core components</Typography> that work
              together to power real-world commerce, DeFi, and everyday use of{' '}
              <Typography component="span">$CRAT</Typography>.
            </>
          ) : (
            <>
              CratD2C is more than just a blockchain - it’s a whole{' '}
              <Typography component="span" fontWeight="bold">
                digital economy.
              </Typography>{' '}
              <br />
              Here’s a breakdown of the{' '}
              <Typography component="span" fontWeight="bold">
                12+1 core components
              </Typography>{' '}
              that work together to
              <br />
              power real-world commerce, DeFi, and everyday use of{' '}
              <Typography component="span" fontWeight="bold">
                $CRAT
              </Typography>
              .
            </>
          )}
        </Typography>
      </Section>
      <CratCircle sx={{ mb: { xs: 10, md: 24 } }} />
    </>
  );
};
